/**
 * @fileoverview Safe HTML rendering utility.
 * Acts as a last-resort defense layer for dangerouslySetInnerHTML usage.
 * All WordPress data should already be sanitized by DOMPurify in the service layer,
 * but this provides defense-in-depth at the component level.
 */

import DOMPurify from 'dompurify';

const SAFE_CONFIG: DOMPurify.Config = {
  ADD_TAGS: ['iframe', 'blockquote'],
  ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'target'],
};

/**
 * Creates a sanitized object ready for React's dangerouslySetInnerHTML.
 * Usage: <div {...safeHTML(content)} />
 */
export function safeHTML(html: string | undefined | null): { dangerouslySetInnerHTML: { __html: string } } {
  const clean = DOMPurify.sanitize(html || '', SAFE_CONFIG);
  return { dangerouslySetInnerHTML: { __html: clean } };
}

/**
 * Strips ALL HTML tags and returns plain text (for alt text, aria-labels, etc).
 */
export function stripHTML(html: string | undefined | null): string {
  if (!html) return '';
  return html.replace(/<[^>]+>/g, '').trim();
}
